import { formatInstrumentExperienceDisplay } from './instrumentExperience';
import { resolveMediaUrl, toPublicProfilePictureUrl } from './mediaUrl';
import { formatProfilePreferredStyles } from './profilePreferredStyles';
import {
  resolveUserAvatarUrl,
  resolveUserDisplayName,
  resolveUserUsername,
} from './userIdentity';

export const resolveUserConnectionName = (connection, fallback = 'Friend') => (
  resolveUserDisplayName(connection, fallback)
);

export const resolveUserConnectionUserId = (connection) => {
  const rawUserId = typeof connection?.userId === 'string'
    ? connection.userId
    : (typeof connection?.user?.id === 'string' ? connection.user.id : null);
  const normalizedUserId = rawUserId?.trim();
  return normalizedUserId || null;
};

export const resolveUserConnectionUsername = (connection) => resolveUserUsername(connection);

export const resolveUserConnectionRole = (connection) => {
  const profile = connection?.profile || {};
  const instrument = formatInstrumentExperienceDisplay(profile.instrumentExperience, {
    maxItems: 1,
    yearsSeparator: ' - ',
  });
  return connection.role
    || connection.subtitle
    || profile.mainInstrument
    || connection?.user?.mainInstrument
    || connection.mainInstrument
    || formatProfilePreferredStyles(profile)
    || instrument
    || null;
};

export const resolveUserConnectionAvatarUrl = (connection, { publicMedia = false } = {}) => {
  const rawUrl = resolveUserAvatarUrl(connection);
  const displayUrl = publicMedia ? (toPublicProfilePictureUrl(rawUrl) || rawUrl) : rawUrl;
  return displayUrl ? resolveMediaUrl(displayUrl) : null;
};

export const resolveUserConnectionHandle = (connection) => {
  const explicitHandle = typeof connection?.handle === 'string' ? connection.handle.trim() : '';
  if (explicitHandle) {
    return `@${explicitHandle.replace(/^@/, '')}`;
  }
  const username = resolveUserConnectionUsername(connection);
  return username ? `@${username}` : null;
};

export const resolveUserConnectionIdentity = (connection, fallback = '') => (
  resolveUserConnectionUserId(connection)
  || resolveUserConnectionUsername(connection)
  || (typeof connection?.id === 'string' ? connection.id.trim() : '')
  || (typeof connection?.friendshipId === 'string' ? connection.friendshipId.trim() : '')
  || fallback
);
